import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  body: {
    width: '100%',
    margin: '30px auto',
    paddingTop: '60px'
  }
});
